import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { actions, Form } from 'react-redux-form';
import PropTypes from 'prop-types';
import { getOutlets } from '../../../actions/outlet';
import RequiredSelect from '../../common/form/elements/required-select';
import ArrowButton from '../../common/button-arrow';
import { getMyProfile, updateVoucher } from '../../../actions/user';

const model = 'deep.voucher_select';

class VoucherSelectionPopup extends Component {
  onSubmit = (formData) => {
    const { dispatch } = this.props;

    dispatch(updateVoucher(formData.voucher))
      .then(() => dispatch(getMyProfile('CURRENT_USER_PROFILE')));
  };

  mapVoucherPayload = (payLoad) => (key) => ({
    voucher_type_id: parseInt(payLoad[key]),
    outlet_id: parseInt(key.split('_').pop()),
  });

  checkVoucherKey = key => /vouchers\_[1-9]+[0-9]*/.test(key);

  mapVoucherValues = (vouchers) => vouchers.map(voucher => ({ label: voucher.name, value: voucher.id }));

  initializeVoucherForm() {
    const { dispatch } = this.props;

    dispatch(actions.change(`${model}.voucher`, ''));
  };

  componentDidMount() {
    const { dispatch, popupActive } = this.props;

    popupActive(true);
    dispatch(getOutlets(true)).then(() => {
      this.initializeVoucherForm();
    });
  }

  componentWillUnmount() {
    const { popupActive } = this.props;

    popupActive(false);
  }

  render() {
    const { vouchers, show } = this.props;

    if (!show) {
      return null;
    }

    return (
      <Modal container={this} show>
        <Modal.Body>
          <p>
            We've noticed you've not selected the voucher you'd like to
            redeem your staff reward points for. Please select a voucher below
            to make sure you don't miss out on your rewards.
          </p>
          <Form model={model} onSubmit={this.onSubmit}>
            <table className="table ignite-table table-hover">
              <thead>
              <tr>
                <th>Select voucher...</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>
                  <RequiredSelect
                    label={""}
                    model=".voucher"
                    values={this.mapVoucherValues(vouchers)}
                  />
                </td>
              </tr>
              </tbody>
            </table>

            <ArrowButton arrow={false} submit={true}>
              Save
            </ArrowButton>
          </Form>
        </Modal.Body>
      </Modal>
    )
  }
}

VoucherSelectionPopup.propTypes = {
  show: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    vouchers: state.stores.vouchers,
    features: state.features
  };
};

export default connect(mapStateToProps)(VoucherSelectionPopup);



// WEBPACK FOOTER //
// ./src/components/store-summary/voucher-select/voucher-selection-popup.jsx